<template>
    <div>
        <label
            :for="`upload-image-common-${id}`"
            :class="`btn ${$props.classLabel}`"
            :style="{ cursor: disabled ? 'not-allowed' : 'pointer' }"
            :disabled="disabled"
            ><span><i class="fa fa-upload" aria-hidden="true"></i></span> {{ $props?.title || $t('btn.uploadFile') }}</label
        >
        <input :disabled="disabled" type="file" :id="`upload-image-common-${id}`" ref="imageInput" hidden @change="displayInfoImage" />
        <slot name="warning"></slot>
        <template v-if="configUpload.isPreview && valueFiles?.length > 0">
            <div v-for="(item, index) in valueFiles" :key="index" class="position-relative preview_img">
                <b-img v-if="item?.path" thumbnail fluid :src="item?.path" :alt="item.origin_name"></b-img>
                <span class="btn_delete_image" @click="onDeleteImage(index)"><i class="ri-close-line" style="vertical-align: bottom"></i></span>
            </div>
        </template>
    </div>
</template>

<script>
import { uploadMethods } from '@/state/helpers';
import { showMessage } from '@/utils/messages';
import { convertKBtoMB } from '@/utils/format';

export default {
    name: 'UploadImages',
    props: {
        fileValues: {
            type: [Array, Object, String],
            default: () => []
        },
        id: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        classLabel: {
            type: String,
            default: 'btn-info'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        processUpload: {
            type: Boolean,
            default: false
        },
        config: {
            type: Object,
            default: () => {
                {
                    return {
                        allowedSize: 1024,
                        allowedExtension: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp'],
                        multiple: false,
                        isPreview: true
                    };
                }
            }
        }
    },
    data() {
        return {
            fileInfo: {
                originName: '',
                extension: '',
                fileSize: 0
            },
            configUpload: {
                allowedSize: 1024,
                allowedExtension: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/bmp'],
                multiple: false,
                isPreview: true
            },
            valueFiles: this.fileValues
        };
    },

    computed: {
        isMultiple() {
            return this.configUpload?.multiple;
        }
    },

    methods: {
        ...uploadMethods,

        displayInfoImage() {
            const imageInput = this.$refs.imageInput;
            if (!imageInput.files.length) return;
            const file = imageInput.files[0];
            let { name, size, type } = file;
            this.fileInfo.originName = name;
            this.fileInfo.extension = name.split('.').pop(); // Lấy phần mở rộng của tệp
            this.fileInfo.type = type; // Lấy phần mở rộng của tệp
            this.fileInfo.fileSize = (size / 1024).toFixed(2); // Chuyển đổi size sang KB và làm tròn đến 2 chữ số thập phân
            this.$refs.imageInput.value = '';
            const lowCaseAllowedExtension = this.configUpload?.allowedExtension?.map((ext) => ext.toLowerCase());
            const lowCaseOriginName = file.name.split('.').pop().toLowerCase();
            if (
                lowCaseAllowedExtension?.length > 0 &&
                lowCaseAllowedExtension?.indexOf(lowCaseOriginName) <= -1 &&
                lowCaseAllowedExtension?.indexOf(this.fileInfo.type) <= -1
            ) {
                showMessage(8080, this.$bvToast, this.$t('uploadFile.format'));
                return;
            }

            if (this.fileInfo.fileSize >= this.configUpload.allowedSize && !this.configUpload?.maxSize) {
                showMessage(8080, this.$bvToast, this.$t('uploadFile.maxSize1MB'));
                return;
            }

            if (this.fileInfo.fileSize >= this.configUpload?.maxSize) {
                showMessage(
                    8080,
                    this.$bvToast,
                    this.$t('uploadFile.maxSizeCustom', {
                        size: convertKBtoMB(this.configUpload?.maxSize)
                    })
                );
                return;
            }
            // 👉 Lấy width & height của ảnh trước khi upload
            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    // Gửi ảnh đi sau khi biết width/height
                    const formData = new FormData();
                    formData.append('image', file);
                    this.$emit('update:processUpload', true);
                    this.acUploadImage(formData).then((data) => {
                        const fileFormat = { ...data.data, width: img.width, height: img.height };
                        if (this.isMultiple) {
                            this.valueFiles.push(fileFormat);
                        } else {
                            this.valueFiles = [fileFormat];
                        }
                        this.$emit('dataFile', fileFormat);
                        this.$emit('update:processUpload', false);
                    });
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        onDeleteImage(idx) {
            this.valueFiles.splice(idx, 1);
            this.$emit('removeFile');
        }
    },

    watch: {
        config: {
            handler: function (newConfig) {
                this.configUpload = {
                    ...this.configUpload,
                    ...newConfig
                };
            },
            immediate: true,
            deep: true
        },

        fileValues: {
            handler: function (newValue) {
                if (newValue && Array.isArray(newValue)) {
                    this.valueFiles = newValue;
                } else {
                    this.valueFiles = newValue ? [newValue] : [];
                }
            },
            immediate: true
        },

        valueFiles: {
            handler: function (newValue) {
                this.$emit('update:fileValues', this.isMultiple ? newValue : newValue?.[0] || null);
            },
            immediate: true,
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
label {
    display: inline-block;
    color: white;
    cursor: pointer;
}
.preview_img {
    width: 200px;
    height: 200px;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 10px;
    }
    .btn_delete_image {
        cursor: pointer;
        position: absolute;
        top: -8px;
        right: -14px;
        font-size: 18px;
        font-weight: 700;
    }
}
</style>
